import { useContext, useRef } from "react";
import { AbortError, validationFailed, ValidationResult, validationSuccessful } from "sprint-common-web";

import { useBucketArchiveApi } from "../api/useBucketArchiveApi";
import { BucketArchiveListingContext } from "../context/BucketArchiveListingContext";
import { CreateBucketArchiveFormInputs } from "./CreateBucketArchiveForm";

export const useCreateBucketArchiveForm = () => {
    const { validateBucketArchiveUniqueId: validateId, createArchiveBucket } = useBucketArchiveApi();

    const { addBucketArchiveItem } = useContext(BucketArchiveListingContext);

    const abortController = useRef<AbortController>(new AbortController());

    const validateUniqueId = async (uniqueId: string | undefined): Promise<ValidationResult> => {
        abortController.current.abort();
        abortController.current = new AbortController();

        if (uniqueId) {
            try {
                const response = await validateId(uniqueId, abortController.current.signal);

                if (!response.isValid) {
                    return validationFailed(response.failures);
                }
            } catch (error) {
                if (error instanceof AbortError) {
                    return validationSuccessful();
                }

                throw error;
            }
        }

        return validationSuccessful();
    };

    const addBucketArchive = async ({ uniqueId }: CreateBucketArchiveFormInputs) => {
        const response = await createArchiveBucket({ uniqueId });

        if (response) {
            addBucketArchiveItem({ uniqueId, bucketName: response?.entityId });
        }
    };

    return {
        validateUniqueId,
        addBucketArchive
    };
};
